// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import { AppLayoutBuiltInErrorBoundary } from '../../../error-boundary/internal';
import { highContrastHeaderClassName } from '../../../internal/utils/content-header-utils';
import { createWidgetizedComponent } from '../../../internal/widgets';
import { AppLayoutNotificationsImplementation as AppLayoutNotifications } from '../notifications';
import { isWidgetReady } from '../state/invariants';
import styles from '../skeleton/styles.css.js';
export const TopContentSlotImplementationInternal = ({ appLayoutProps, appLayoutState }) => {
    if (!isWidgetReady(appLayoutState)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        appLayoutProps.notifications && (React.createElement("div", { className: clsx(styles['notifications-background'], appLayoutProps.headerVariant === 'high-contrast' && highContrastHeaderClassName) })),
        appLayoutProps.notifications && (React.createElement(AppLayoutNotifications, { appLayoutInternals: appLayoutState.appLayoutInternals }, appLayoutProps.notifications))));
};
export const TopContentSlotImplementation = (props) => (React.createElement(AppLayoutBuiltInErrorBoundary, { appLayoutPart: "top-content-slot" },
    React.createElement(TopContentSlotImplementationInternal, { ...props })));
export const createWidgetizedAppLayoutTopContentSlot = createWidgetizedComponent(TopContentSlotImplementation);
//# sourceMappingURL=top-content-slot.js.map